import React from 'react';

const Select = ({ id, name, value, onChange, label, options, required }) => {
    return (
        <div>
            <label htmlFor={id}>{label}:</label>
            <select id={id} name={name} value={value} onChange={onChange} required={required}>
                {options.map((option) => (
                    <option key={option.value} value={option.value}>{option.label}</option>
                ))}
            </select>
        </div>
    );
};

export default Select;
